import { Controller, useFormContext, useWatch } from "react-hook-form";
import React from "react";
import SelectDropdown from "../../form/components/SelectDropdown";
import AccountSelector from "./selectors/AccountSelector";
import SubAccountSelector from "./selectors/SubAccountSelector";
import { AccountLevel } from "../../account/utils";
import { UIGrid, UITypography } from "../../_app/components";
import { useContextProvider } from "../../context/providers/ContextProvider";

interface Props {
  classes?: any;
}

const userLevelList = [
  { label: AccountLevel.Account.label, value: AccountLevel.Account.id, id: AccountLevel.Account.id },
  { label: AccountLevel.SubAccount.label, value: AccountLevel.SubAccount.id, id: AccountLevel.SubAccount.id },
];

const EditAccountDetailsForm = ({ classes }: Props) => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  const { contextData } = useContextProvider();

  const selectedLevel = useWatch({ control, name: "userLevel" });

  return (
    <>
      <UIGrid size={{ xs: 12, md: 4 }}>
        <UITypography variant="h3" gutterBottom>
          Account details
        </UITypography>
      </UIGrid>
      <UIGrid size={{ xs: 12, md: 8 }}>
        <Controller
          name="userLevel"
          control={control}
          render={({ field }) => (
            <SelectDropdown
              disabled={contextData?.level?.id !== AccountLevel.Account.id}
              {...field}
              onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                field.onChange(e);
                setValue("accounts", []);
              }}
              label="User level"
              data={userLevelList}
              ctrClass={classes.textField}
              error={!!errors?.userLevel}
              helperText={errors?.userLevel?.message as string | undefined}
            />
          )}
        />

        {selectedLevel === AccountLevel.Account.id && <AccountSelector classes={classes} />}
        {selectedLevel === AccountLevel.SubAccount.id && <SubAccountSelector classes={classes} />}
      </UIGrid>
    </>
  );
};

export default EditAccountDetailsForm;
